export const GA = null;

export const messages = {
	found: 'This password appeared in a data breach and should never be used. If you use it anywhere, change it!',
	notFound: 'This password was not found in any known data breach.',
	initial: 'Enter your password to see if it has been located in any leaks.',
};
